function initializeBackToCart() {
  var productForm = document.querySelector('.product-form');
  var stickyAddToCart = document.getElementById('sticky-add-to-cart');
  var stickyAddToCartButton = document.getElementById('sticky-add-to-cart-button');
  var body = document.querySelector('body.cg-theme');
  var stickyHeight = stickyAddToCart.offsetHeight;
  
  stickyAddToCart.style.visibility = 'visible';  
  stickyAddToCart.style.bottom = -stickyHeight + 'px';
  
  function adjustFooterMargin() {
    if (stickyAddToCart && body) {
      body.style.marginBottom = stickyHeight + 'px';
    }
  }
  
  if (productForm && stickyAddToCart) {
    window.addEventListener('scroll', function() {
      var formRect = productForm.getBoundingClientRect();
      if (formRect.bottom < 0) {
        stickyAddToCart.style.bottom = '0px';
      } else {
        stickyAddToCart.style.bottom = -stickyHeight + 'px';
      }
      
      adjustFooterMargin();
    });
    
    stickyAddToCartButton.addEventListener('click', function() {
      var endPosition = productForm.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight + 15;
      var startPosition = window.pageYOffset;
      var distance = endPosition - startPosition;
      var duration = 1000;
      var startTime = null;
      
      function scrollAnimation(currentTime) {
        if (startTime === null) startTime = currentTime;
        var timeElapsed = currentTime - startTime;
        var nextScrollPosition = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, nextScrollPosition);
        if (timeElapsed < duration) requestAnimationFrame(scrollAnimation);
      }
      
      function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      }
      
      requestAnimationFrame(scrollAnimation);
    });
  }
};

function triggerScrollEvent() {
  var scrollEvent = new Event('scroll');
  window.dispatchEvent(scrollEvent);
}

document.addEventListener("DOMContentLoaded", initializeBackToCart);

// Reinitialize on Shopify's theme editor events
document.addEventListener('shopify:section:load', initializeBackToCart);
document.addEventListener('shopify:section:unload', initializeBackToCart);
document.addEventListener('shopify:block:select', initializeBackToCart);
document.addEventListener('shopify:block:deselect', initializeBackToCart);

document.addEventListener('shopify:section:load', triggerScrollEvent);
